module.exports = __webpack_public_path__ + "static/deals-for-you-admin-dc3491e03696a5e7d2acea0413cdbc4c.png";